import styled from 'styled-components';
import { token } from '@zillow/constellation';
import { ContentBox } from '@zillow/zrs-comet';

export const StyledContentBox = styled(ContentBox)`
    border: 1px solid ${token('colors.blue300')};
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    margin: 8px 0;
`;
